import {
  aFavoriteField,
  aFavoriteFieldPage,
  FavoriteFieldType,
  mockFavoriteFieldsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { INVENTORY_FAVORITE_FIELD_OVERRIDES } from '@sbu/configs.mocks';

export const handlers = [
  mockFavoriteFieldsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          favoriteFields: aFavoriteFieldPage({
            objects: [
              aFavoriteField({
                fieldName: INVENTORY_FAVORITE_FIELD_OVERRIDES.fieldName,
                fieldType:
                  INVENTORY_FAVORITE_FIELD_OVERRIDES.fieldType as FavoriteFieldType,
              }),
            ],
          }),
        },
      });
    }
  ),
];
